/**
 * Format fees for Shows and Auctions.
 * If fee is provided and > 0, returns the value with the AED currency.
 * Otherwise returns the localized word 'Free' ('مجاني').
 *
 * @param {number|string} fee - The fee value
 * @param {function} translate - Translation function
 * @param {string} [currentLanguage='en'] - Current language code ('ar' or 'en')
 * @returns {string} Formatted fee string or 'Free'
 */
export const formatFee = (fee, translate, currentLanguage = 'en') => {
  const isArabic = currentLanguage === 'ar';
  const defaultFree = isArabic ? 'مجاني' : 'Free';
  const defaultAed = isArabic ? 'د.إ' : 'AED';
  const freeLabel = translate ? translate('web.free', defaultFree) : defaultFree;
  const aedLabel = translate ? translate('web.aed', defaultAed) : defaultAed;

  if (fee === undefined || fee === null || fee === '' || fee === false) {
    return freeLabel;
  }

  const cleanNum = typeof fee === 'string' ? parseFloat(fee.replace(/,/g, '')) : parseFloat(fee);

  if (!isNaN(cleanNum) && cleanNum > 0) {
    return `${fee} ${aedLabel}`;
  }

  return freeLabel;
};

export default formatFee;
